<div class="settings-overlay" (click)="onClose()"></div>

<div class="settings-container" (click)="$event.stopPropagation()">
  <!-- Header -->
  <div class="settings-header">
    <div class="header-left">
      <button class="back-button" (click)="onClose()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 15L7.5 10L12.5 5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div class="header-title-group">
        <h1 class="settings-title">Carwash Website Builder</h1>
        <span class="settings-subtitle">Last saved: Just now</span>
      </div>
      <span class="draft-badge">Draft</span>
    </div>
  </div>

  <!-- Main Content -->
  <div class="settings-content">
    <!-- Left Sidebar -->
    <div class="settings-sidebar">
      <div class="sidebar-section">
        <div class="sidebar-section-header">
          <span class="sidebar-section-title">Settings</span>
        </div>

        <div class="sidebar-menu">
          <button
            class="sidebar-item"
            [class.active]="activeSidebarItem === 'general'"
            (click)="onSidebarItemClick('general')"
          >
            <img
              src="assets/icons/settings/settings-icon.svg"
              alt="Settings"
              width="20"
              height="20"
            />
            <span>General</span>
          </button>

          <button
            class="sidebar-item"
            [class.active]="activeSidebarItem === 'domains'"
            (click)="onSidebarItemClick('domains')"
          >
            <img src="assets/icons/settings/world-icon.svg" alt="Domains" width="20" height="20" />
            <span>Domains</span>
          </button>
        </div>
      </div>

      <div class="sidebar-section" *ngIf="websitePages.length > 0">
        <div class="sidebar-section-header">
          <span class="sidebar-section-title">SEO Settings</span>
        </div>

        <div class="sidebar-menu">
          <button
            *ngFor="let page of websitePages; let i = index; trackBy: trackByIndex"
            class="sidebar-item"
            [class.active]="activeSeoItem === getPageId(page)"
            (click)="onSeoItemClick(getPageId(page))"
          >
            <img
              [src]="'assets/icons/settings/file-icon' + (i === 0 ? '' : '-' + (i + 1)) + '.svg'"
              [alt]="getPageName(page)"
              width="20"
              height="20"
              onerror="this.src = 'assets/icons/settings/file-icon.svg'"
            />
            <span>{{ getPageName(page) }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="settings-main" *ngIf="activeSidebarItem === 'general'">
      <div class="main-header">
        <div class="main-header-text">
          <h2 class="main-title">General</h2>
          <p class="main-description">Track and manage your campaigns</p>
        </div>
      </div>

      <!-- Tabs -->
      <app-tab-header [tabs]="tabs" [activeTabId]="activeTab" (tabChange)="onTabChange($event)">
      </app-tab-header>

      <!-- Tab Content -->
      <div class="tab-content" *ngIf="activeTab === 'site-settings'">
        <!-- Site Title -->
        <div class="form-section">
          <div class="form-group">
            <label class="form-label">Site Title</label>
            <input
              type="text"
              class="form-input"
              [(ngModel)]="settings.siteTitle"
              placeholder="Enter site title"
            />
          </div>

          <!-- Site Description -->
          <div class="form-group">
            <label class="form-label">Site Description</label>
            <textarea
              class="form-textarea"
              [(ngModel)]="settings.siteDescription"
              rows="4"
              placeholder="Type your description here"
            ></textarea>
          </div>

          <!-- Preview Card -->
          <div class="preview-card">
            <div class="preview-header">
              <span class="preview-label">Preview</span>
            </div>

            <div class="preview-content">
              <div class="preview-url">{{ settings.siteUrl }}</div>
              <h3 class="preview-title">{{ settings.siteTitle }}</h3>
              <p class="preview-description">{{ settings.siteDescription }}</p>
            </div>
          </div>

          <!-- Unpublish Section -->
          <div class="unpublish-section">
            <div class="unpublish-content">
              <div class="unpublish-text">
                <h3 class="unpublish-title">Unpublish website</h3>
                <p class="unpublish-description">Unpublish your website from all domains.</p>
              </div>

              <button class="unpublish-btn" (click)="onUnpublish()">
                <span>Unpublish</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Site Images Tab -->
      <div class="tab-content" *ngIf="activeTab === 'site-images'">
        <div class="form-section">
          <!-- Favicon Section -->
          <div class="form-group">
            <label class="form-label">Favicon</label>

            <!-- Info Box -->
            <div class="info-box">
              <svg
                class="info-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="10" cy="10" r="9" stroke="#717683" stroke-width="1.5" />
                <path
                  d="M10 6V10M10 14H10.01"
                  stroke="#717683"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
              <p class="info-text">
                The favicon currently placed here is from the logo uploaded in the branding. To
                optimize the favicon further, you may replace the favicon by uploading it.
              </p>
            </div>

            <!-- Favicon Preview -->
            <div class="favicon-preview-container">
              <div class="browser-tab-preview">
                <img
                  src="assets/images/site-images/favicon.svg"
                  alt="Favicon Preview"
                  class="favicon-preview-image"
                />
              </div>

              <div class="preview-info">
                <span class="preview-theme">Light Theme</span>
                <span class="preview-dimensions">64 x 64 pixels</span>
              </div>

              <button class="replace-btn" type="button" (click)="onReplaceFavicon()">
                Replace
              </button>
            </div>
          </div>

          <!-- Social Preview Section -->
          <div class="form-group">
            <label class="form-label">Social Preview</label>

            <!-- Social Preview Image -->
            <div class="social-preview-container">
              <div class="social-preview-image">
                <img
                  *ngIf="socialPreview"
                  [src]="socialPreview"
                  alt="Social Preview"
                  class="social-image"
                />
                <div *ngIf="!socialPreview" class="social-preview-placeholder">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="48" height="48" rx="8" fill="#F3F5F9" />
                    <path
                      d="M24 16V32M16 24H32"
                      stroke="#A8ACB0"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  <p>No image uploaded</p>
                </div>
              </div>

              <div class="preview-info">
                <span class="preview-dimensions">1200 x 630 pixels</span>
              </div>

              <button class="upload-btn" type="button" (click)="onUploadSocialPreview()">
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Analytics Tab -->
      <div class="tab-content analytics-tab-content" *ngIf="activeTab === 'analytics'">
        <div class="analytics-section">
          <!-- Google Analytics Measurement ID Card -->
          <div class="analytics-card">
            <div class="analytics-row">
              <label class="analytics-label">Google Analytics Measurement ID</label>
              <div class="analytics-input-wrapper">
                <input
                  type="text"
                  class="analytics-input"
                  placeholder="G-XXXXXXXXXX"
                  [(ngModel)]="analyticsSettings.googleAnalyticsId"
                  (input)="onAnalyticsInput()"
                />
                <p class="analytics-description">
                  Easily connect Google Analytics to your site to track performance and visitor
                  insights. As the site owner, you are responsible for ensuring compliance with
                  privacy regulations such as GDPR.
                </p>
              </div>
            </div>
          </div>

          <!-- Cookie Banner ID Card -->
          <div class="analytics-card">
            <div class="analytics-row">
              <label class="analytics-label">Cookie Banner ID</label>
              <div class="analytics-input-wrapper">
                <input
                  type="text"
                  class="analytics-input"
                  placeholder="GTM-XXXXXXXXXX"
                  [(ngModel)]="analyticsSettings.cookieBannerId"
                  (input)="onAnalyticsInput()"
                />
                <p class="analytics-description">
                  Google Tag Manager(GTM) container ID in the format GTM-XXXXXXXX to enable the
                  cookie banner on your website. This ID allows your cookie consent settings to be
                  managed seamlessly through Google Tag Manager.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SEO Settings Content -->
    <div class="settings-main" *ngIf="activeSeoItem">
      <div class="main-header">
        <div class="main-header-text">
          <h2 class="main-title">SEO Settings</h2>
          <p class="main-description">
            Update page title and description to keep content accurate and SEO-friendly.
            <span *ngIf="isSavingSeo" class="saving-indicator">Saving...</span>
          </p>
        </div>
      </div>

      <div class="seo-content">
        <div class="form-section">
          <!-- Page Title -->
          <div class="form-group">
            <label class="form-label">Page Title</label>
            <input
              type="text"
              class="form-input"
              [ngModel]="getCurrentSeoSettings().pageTitle"
              (ngModelChange)="onSeoTitleChange($event)"
              placeholder="Enter page title"
            />
          </div>

          <!-- Page Description -->
          <div class="form-group">
            <label class="form-label">Page Description</label>
            <textarea
              class="form-textarea"
              [ngModel]="getCurrentSeoSettings().pageDescription"
              (ngModelChange)="onSeoDescriptionChange($event)"
              rows="4"
              placeholder="Type your description here"
            ></textarea>
          </div>

          <!-- Preview -->
          <div class="form-group">
            <label class="form-label">Preview</label>
            <div class="preview-card">
              <div class="preview-header">
                <span class="preview-label">Preview</span>
              </div>
              <div class="preview-content">
                <div class="preview-url">{{ settings.siteUrl || 'yoursite.url' }}</div>
                <div class="preview-title">{{ getCurrentSeoSettings().pageTitle }}</div>
                <div class="preview-description">{{ getCurrentSeoSettings().pageDescription }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Domains Content -->
    <div class="settings-main" *ngIf="activeSidebarItem === 'domains'">
      <div class="main-header">
        <div class="main-header-text">
          <h2 class="main-title">Domains</h2>
          <p class="main-description">Manage and connect your website domains easily.</p>
        </div>
      </div>

      <div class="domains-content">
        <div class="domains-card">
          <div class="domains-card-header">
            <h3 class="domains-card-title">Domain Name</h3>
          </div>

          <div class="domain-options">
            <!-- Get a Way subdomain -->
            <div class="domain-option">
              <div class="domain-option-header">
                <label class="radio-label">
                  <input
                    type="radio"
                    name="domainType"
                    value="subdomain"
                    [(ngModel)]="domainType"
                    class="radio-input"
                  />
                  <span class="radio-custom"></span>
                </label>
                <div class="domain-option-content">
                  <div class="domain-option-title">Get a Way subdomain</div>
                  <div class="domain-option-description">
                    Publish your site with a platform-provided subdomain.
                  </div>
                </div>
              </div>

              <div class="domain-input-group" *ngIf="domainType === 'subdomain'">
                <div class="domain-input-wrapper">
                  <div class="domain-input-container">
                    <svg
                      class="domain-input-icon"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM10 16C6.69 16 4 13.31 4 10C4 6.69 6.69 4 10 4C13.31 4 16 6.69 16 10C16 13.31 13.31 16 10 16ZM9 11V13H11V11H9ZM9 7V9H11V7H9Z"
                        fill="#A0A6D4"
                      />
                    </svg>
                    <input
                      type="text"
                      class="domain-input"
                      [class.error]="subdomainError"
                      [(ngModel)]="subdomainName"
                      (input)="onSubdomainInput()"
                      (blur)="onSubdomainInput()"
                      placeholder="Enter domain address"
                    />
                    <span class="domain-suffix">{{ subdomainSuffix }}</span>
                  </div>
                  <div class="validation-error" *ngIf="subdomainError">
                    {{ subdomainError }}
                  </div>
                </div>
                <button
                  class="domain-confirm-btn"
                  type="button"
                  [disabled]="isSaving('subdomain') || !isDomainInputReady('subdomain')"
                  [attr.aria-busy]="isSaving('subdomain')"
                  aria-label="Confirm subdomain"
                  (click)="onDomainConfirm('subdomain')"
                >
                  <span class="spinner" *ngIf="isSaving('subdomain')"></span>
                  <svg
                    *ngIf="!isSaving('subdomain')"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"
                      fill="#717683"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Connect custom domain -->
            <div class="domain-option">
              <div class="domain-option-header">
                <label class="radio-label">
                  <input
                    type="radio"
                    name="domainType"
                    value="customdomain"
                    [(ngModel)]="domainType"
                    class="radio-input"
                  />
                  <span class="radio-custom"></span>
                </label>
                <div class="domain-option-content">
                  <div class="domain-option-title">Connect custom domain</div>
                  <div class="domain-option-description">
                    Link a domain you own from any hosting provider.
                  </div>
                </div>
              </div>

              <div class="domain-input-group" *ngIf="domainType === 'customdomain'">
                <div class="domain-input-wrapper">
                  <div class="domain-input-container">
                    <svg
                      class="domain-input-icon"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM10 16C6.69 16 4 13.31 4 10C4 6.69 6.69 4 10 4C13.31 4 16 6.69 16 10C16 13.31 13.31 16 10 16ZM9 11V13H11V11H9ZM9 7V9H11V7H9Z"
                        fill="#A0A6D4"
                      />
                    </svg>
                    <input
                      type="text"
                      class="domain-input"
                      [class.error]="customDomainError"
                      [(ngModel)]="customDomainName"
                      (input)="onCustomDomainInput()"
                      (blur)="onCustomDomainInput()"
                      placeholder="Enter domain address"
                    />
                  </div>
                  <div class="validation-error" *ngIf="customDomainError">
                    {{ customDomainError }}
                  </div>
                </div>
                <button
                  class="domain-confirm-btn"
                  type="button"
                  [disabled]="isSaving('customdomain') || !isDomainInputReady('customdomain')"
                  [attr.aria-busy]="isSaving('customdomain')"
                  aria-label="Confirm custom domain"
                  (click)="onDomainConfirm('customdomain')"
                >
                  <span class="spinner" *ngIf="isSaving('customdomain')"></span>
                  <svg
                    *ngIf="!isSaving('customdomain')"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"
                      fill="#717683"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

